import { Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/system";

const Container = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "flex-start",
	alignItems: "flex-start",
	width: "100%",
	padding: "1rem 1rem 1rem 1rem",
	background: theme.palette.background.paper,
	margin: "0rem 0rem 0rem 0rem",
	borderRadius: "16px",
}));

const Heading = styled(Typography)(({ theme }) => ({
	margin: "0rem 0rem 0.5rem 0rem",
	width: "100%",
	fontWeight: "500",
	fontSize: "1rem",
	[theme.breakpoints.up("sm")]: {
		fontSize: "1rem",
	},
	[theme.breakpoints.up("md1190")]: {
		fontSize: "1.125rem",
	},
}));

const SocialButtonsConatiner = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-around",
	alignItems: "flex-start",
	width: "100%",
	margin: "0rem 0rem 0rem 0rem",
}));

const SocialPaper = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	height: "4.5rem !important",
	width: "4.5rem !important",
	gap: "0.5rem",
	margin: "0.5rem 0rem 0.5rem 0rem",
	borderRadius: "8px",
	cursor: "pointer",
	// "@media (pointer:fine)": {
	// 	"&:hover": {
	// 		scale: "1.1",
	// 	},
	// },
}));

const CopyRow = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "center",
	margin: "0.5rem 0rem 0rem 0rem",
	width: "100%",
	[theme.breakpoints.down("sm")]: {
		width: "100% !important",
		padding: "0rem",
	},
}));

const SharePropertyDesktopSkeleton = () => {
	return (
		<Container>
			<Heading>
				<Skeleton
					animation="wave"
					variant="rectangular"
					width="10rem"
					height="1rem"
					style={{ borderRadius: "0.5rem" }}
				/>
			</Heading>
			<SocialButtonsConatiner>
				<SocialPaper>
					<Skeleton
						animation="wave"
						variant="rectangular"
						width="2.5rem"
						height="2.5rem"
						style={{ borderRadius: "0.5rem" }}
					/>
				</SocialPaper>
				<SocialPaper>
					<Skeleton
						animation="wave"
						variant="rectangular"
						width="2.5rem"
						height="2.5rem"
						style={{ borderRadius: "0.5rem" }}
					/>
				</SocialPaper>
				<SocialPaper>
					<Skeleton
						animation="wave"
						variant="rectangular"
						width="2.5rem"
						height="2.5rem"
						style={{ borderRadius: "0.5rem" }}
					/>
				</SocialPaper>
			</SocialButtonsConatiner>

		</Container>
	);
};

export default SharePropertyDesktopSkeleton;
